import { useMutation } from "react-query";
import { fetchBinaryContent } from "@/services/binary";
/** Mutation hook that resolves an EMR binary's downloadable content on demand. */
export function useBinaryContent(workspaceId, patientId) {
  return useMutation(function (payload) {
    return fetchBinaryContent(workspaceId, patientId, payload);
  });
}